function vibrateFunc(){
    navigator.vibrate(2000); // Вибрация на 200 миллисекунд

}
export default vibrateFunc;